<template>
  <div class="modal-dialog">
    <div class="card">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h5 class="modal-title" id="staticBackdropLabel10"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="close1"></button>
        </div>
        <div class="modal-body text-center pt-4 pb-4 mt-n3">
          <i class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"></i>

          <h6>{{ $t("modal_pending.title") }}</h6>

          <p class="text-justify">
            <span v-if="selectedStudentsCount <= 1">
              {{ $t('modal_pending.confirm_single', { studentName: selectedStudentName || '', amount: currency_code + ' ' + Number(paymentAmount || amount).toLocaleString() }) }}
            </span>
            <span v-else>
              {{ $t('modal_pending.confirm_multiple', { count: selectedStudentsCount, amount: currency_code + ' ' + Number(paymentAmount || amount).toLocaleString() }) }}
            </span>
            <br />
            {{ $t('modal_pending.confirm_note') }}
          </p>
          <div class="table-tranche mt-4 mb-5">
            <table class="table" style="border: 1px solid rgba(255, 255, 255, 0.4)">
              <thead>
                <tr>
                  <th scope="col" style="border-right: 1px solid rgba(255, 255, 255, 0.4)">
                    <span v-if="installmentNumber"> {{ $t("modal_pending.installment") }}</span>
                    <span v-if="paymentDescription">Designation</span>

                  </th>
                  <th scope="col" style="border-right: 1px solid rgba(255, 255, 255, 0.4)">
                    {{ $t("modal_pending.amount") }}
                  </th>
                  <th scope="col">{{ $t("modal_pending.due_date") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="border-right: 1px solid rgba(255, 255, 255, 0.4);">
                    <span v-if="paymentDescription">{{ paymentDescription }}</span>
                    <span v-if="installmentNumber">{{ installmentNumber }} </span>
                  </td>
                  <td style="border-right: 1px solid rgba(255, 255, 255, 0.4)">
                    <span v-if="paymentAmount"> {{ currency_code }} {{ Number(paymentAmount).toLocaleString() }} </span>
                    <span v-if="amount"> {{ currency_code }} {{ Number(amount).toLocaleString() }} </span>

                  </td>
                  <td>
                    <span v-if="due_date">{{ due_date }}</span>
                    <span v-if="paymentDate"> {{ formatDate(paymentDate) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="showAlert" class="alert " id="alert-modal" role="alert">
            <i class="bi bi-exclamation-triangle-fill text-warning fs-4 mx-3"></i>
            {{ $t("modal_pending.alert") }}
          </div>
        </div>
        <div class="modal-footer border-0 pb-5 mb-1">
          <argon-button type="button" class="btn bg-transparent"  title="Fermer"
            data-bs-dismiss="modal" style="width: 200px; height: 50px; padding-top: 15px; border: 1px solid rgba(255, 255, 255, 0.4);" @click="annuler">
            <span>
              {{ $t("button.cancel") }}
            </span>
          </argon-button>
          <argon-button type="button" class="btn btn-custom" color="success" variant="gradient"
            style="width: 200px; height: 50px; padding-top: 15px" @click="confirmAction"
            :disabled="!isChoiceMade || loading || buttonDisabled">
            <span v-if="!loading">
              {{ $t("button.confirm") }}
            </span>
            <span v-else>
              <i class="fas fa-spinner fa-spin"></i>
            </span>
          </argon-button>

        </div>
      </div>
    </div>
  </div>
</template>




<script>
import ArgonButton from "@/components/ArgonButton";
import api_config from "@/config";

export default {
  name: 'Modal-Pending',
  components: {
    ArgonButton
  },
  props: {
    amount: {
      type: Number,
      required: true
    },
    paymentDescription: {
      type: String,
      required: false,
      default: ''
    },
    paymentDate: {
      type: String,
      required: false,
      default: ''
    },
    paymentAmount: {
      type: Number,
      required: false,
      default: 0
    },
    selectedStudentName: {
      type: String,
      required: false,
      default: ''
    },
    installmentNumber: {
      type: Number,
      required: true
    },
    due_date: {
      type: String,
      required: true
    },
    paymentId: {
      type: String,
      required: true
    },
    updatestudentstatut: {
      type: Function,
      required: true
    },
    updatestatutsettled: {
      type: Function,
      required: true
    }
    ,
    selectedStatus: {
      type: String,
      required: false,
      default: 'Pending'
    },
    selectedStudentsCount: {
      type: Number,
      required: false,
      default: 0
    },
    selectedInstallmentId: {
      type: [String, Number],
      required: false,
      default: null
    },
    close1: {
      type: Function,
      required: false,
    }
  },
  data() {
    return {
      showPending: false,
      showSettled: false,
      isChoiceMade: true,
      loading: false,
      showAlert: false,
      buttonDisabled: false,
      currency_code: api_config.CURRENCY_CODE,  
    };
  },
  methods: {
    async confirmAction() {
      // Confirmation modal: call parent function to perform API action
      this.showAlert = false;
      this.loading = true;
      this.buttonDisabled = true;

      try {
        if (String(this.selectedStatus).toLowerCase() === 'pending') {
          // Parent will handle creating payments if needed
          await this.updatestudentstatut();
        } else {
          await this.updatestatutsettled();
        }

        // Emit event to parent that operation is complete
        this.$emit('confirmed');
        // Do not call close1() here — parent will control showing the "send" modal.
      } catch (err) {
        console.error('Error during confirmAction:', err);
        this.showAlert = true;
      } finally {
        this.loading = false;
        this.buttonDisabled = false;
      }
    },
    annuler() {
      this.showPending = false;
      this.showSettled = false;
      this.isChoiceMade = true;
      this.showAlert = false;
      this.buttonDisabled = false;
      if (typeof this.close1 === 'function') this.close1();
    },
    togglePending() {
      this.showPending = true;
      this.showSettled = false;
      this.isChoiceMade = true;
      this.showAlert = false;
    },
    toggleSettled() {
      this.showPending = false;
      this.showSettled = true;
      this.isChoiceMade = true;
      this.showAlert = false;
    },
    ParentUpdatestudentstatut() {
      this.updatestudentstatut();
    },
    Parentupdatestatutsettled() {
      this.updatestatutsettled();
    }
  }
};

</script>



<style>
#pending,
#settled {
  text-align: justify;
  margin-left: auto;
  margin-right: auto;
  padding: 8px;
  border: 1px solid green;
}

#alert-modal {
  border: 1px solid #83454d;
  color: #83454d;
  background: rgba(0, 0, 0, 0.6)
}
</style>
